import { AfaModal } from '../../ui/AfaModal';
import { AfaButton } from '../../ui/AfaButton';
import { AfaEntitatCard } from '../../ui/AfaEntitatCard';
import { Stack, Text, Flex, ScrollArea } from '@mantine/core';
import { useState } from 'react';
import { AfaAlert } from '../../ui';

interface CambiarEntitatModalProps {
  ENTITATS_DATA: any[];
  opened: boolean;
  onClose: () => void;
  onSubmit: (entitatName: string) => void;
  currentEntitat?: string;
}

export function CambiarEntitatModal({
  ENTITATS_DATA,
  opened,
  onClose,
  onSubmit
}: CambiarEntitatModalProps) {
  const [selectedEntitat, setSelectedEntitat] = useState<string>('entitat1');

  return (
    <AfaModal
      opened={opened}
      onClose={onClose}
      title="Canviar d'Entitat"
      primaryButtonText="Canviar"
      secondaryButtonText="Cancel·lar"
      onPrimaryAction={onSubmit}
      onSecondaryAction={onClose}
      size='lg'
    >
      <Stack gap="4px">
        <ScrollArea type="auto">
          <Stack gap="md">
            <AfaAlert type="info">
              Selecciona l'entitat que vols contextualitzar.
            </AfaAlert>

            <Stack gap="xs">
              {ENTITATS_DATA.map((entitat) => (
                <AfaEntitatCard
                  key={entitat.lookupId}
                  entityName={entitat.lookupValue}
                  filials={entitat.filials}
                  checked={selectedEntitat === entitat}
                  onClick={() => setSelectedEntitat(entitat)}
                  value={entitat}
                />
              ))}
            </Stack>
          </Stack>
        </ScrollArea>
        <p></p>
        <Flex justify="flex-end" gap={16}>
          {/* <AfaButton variant="outline" onClick={() => {
            document.cookie = "entityOV=" + JSON.stringify(selectedEntitat);
            onSubmit(selectedEntitat);
          }
          }>
            Definir com a principal i avançar
          </AfaButton> */}
          <AfaButton variant="filled" onClick={() => {
            document.cookie = "entityOV=" + JSON.stringify(selectedEntitat);
            onSubmit(selectedEntitat);
          }
          }>
            Avançar
          </AfaButton>
        </Flex>
      </Stack>
    </AfaModal>
  );
}
